module.exports = __webpack_public_path__ + "img/ponte-2.8e0f2018.png";